export const DEFAULT_INSTALLATION_ID = 0;
export const INSTALLATION_PROGRESS = 'installationProgress';
export const INSTALLATION = 'installation';
